export const authConfig = {
    domain: process.env.REACT_APP_DOMAIN,
    clientId: process.env.REACT_APP_CLIENT_ID,
    redirectUri: process.env.REACT_APP_REDIRECT_URL,
    logoutRedirectUri: process.env.REACT_APP_LOGOUT_URL,
};